/**
 * Utility function to extract review status from auditor_review data
 * Handles both structured and legacy formats
 */
export const getReviewStatus = (auditorReview: any, auditId?: string): string | null => {
  if (!auditorReview) return null
  if (typeof auditorReview === 'object' && auditorReview.status) {
    return auditorReview.status
  }
  
  if (typeof auditorReview === 'string') {
    return auditorReview
  }
  
  if (typeof auditorReview === 'object') {
    const auditKeys = Object.keys(auditorReview)
    
    if (auditId && auditKeys.includes(auditId)) {
      const specificAuditReview = auditorReview[auditId]
      if (specificAuditReview && typeof specificAuditReview === 'object' && specificAuditReview.status) {
        return specificAuditReview.status
      }
    }
    
    return null
  }
  
  return null
}
